function requirementState(password) {
  return [
    {
      id: 'length',
      label: 'Pelo menos 8 caracteres',
      met: password.length >= 8,
    },
    {
      id: 'letter',
      label: 'Ao menos 1 letra',
      met: /[A-Za-z]/.test(password),
    },
    {
      id: 'number',
      label: 'Ao menos 1 numero',
      met: /\d/.test(password),
    },
  ]
}

export function isPasswordStrongEnough(password) {
  return requirementState(password).every((item) => item.met)
}

export default function PasswordChecklist({ password }) {
  const items = requirementState(password)

  return (
    <div className="password-checklist" aria-live="polite">
      {items.map((item) => (
        <div
          key={item.id}
          className={`password-check ${item.met ? 'is-valid' : 'is-idle'}`}
        >
          <span className="password-check-dot" aria-hidden="true" />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  )
}
